export type RepeatSeverity = "critical" | "warning";

// Inclusive lower bounds: >3 per day, >7 per week, >=15 per month.
// These are attention heuristics for the returned top, not bank health metrics.
// Interpolate between anchors and round up. The 31-day anchor gives 15 for
// calendar months of 28–31 days. Longer periods scale from the month anchor.
export const BANK_ANALYSIS_CONFIG = {
	repeatedEntities: {
		day: { days: 1, minCount: 4, severity: "critical" as RepeatSeverity },
		week: { days: 7, minCount: 8, severity: "warning" as RepeatSeverity },
		month: { days: 31, minCount: 15, severity: "warning" as RepeatSeverity },
	},
};
